import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { Reversiones } from '../models/reversiones.model';
import { LogisticaService } from '../services/logistica.service';

@Component({
  selector: 'app-consulta-reversiones-op',
  templateUrl: './consulta-reversiones-op.component.html',
  styleUrls: ['./consulta-reversiones-op.component.scss']
})
export class ConsultaReversionesOpComponent implements OnInit {
  reversiones: Reversiones[] = []
  doc?: number;

  constructor(
    private logiticaService: LogisticaService,
    private helpers: HelpersService) { }

  ngOnInit(): void {
  }

  async ObtenerConsultaReversion(doc: number) {
    var obj_response = await this.logiticaService.getConsultaReversion(doc);
    if (obj_response.success === true) {
      this.reversiones = obj_response.data;
    }
  }

  consultar(event) {
    showSpinner()
    const filterValue = (event.target as HTMLInputElement).value;
    this.doc = parseInt(filterValue);

    this.ObtenerConsultaReversion(this.doc);
    hideSpinner()
  }

}
